// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2g-JI","notes":"Notes_notes__2i2bo"};